import styled, { css } from 'styled-components';
import Button from '@bitcoin-portal/bitcoincom-pkg-components/dist/Button';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';

export const QrCodeModalWrapper = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

export const StyledTitle = styled.div`
  font-weight: 500;
  margin-top: 20px;
  line-height: 89%;
  font-size: 34px;
  letter-spacing: -0.68px;
  text-transform: uppercase;
  font-family: 'Elza Condensed', sans-serif;
  color: var(--Primary-Darknet, #1c1c1c) !important;
`;

export const StyledSubtitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  padding: 12px 0px;
  font-family: 'Satoshi Variable Medium', sans-serif;
  line-height: 135%;
  letter-spacing: -0.32px;
  color: var(--Shades-700, #67656e);
  text-align: center;
`;

export const QrCodeWrapper = styled.div`
  margin: 12px 0px;
  & > div {
    width: 100%;
  }
`;

export const ModalCTA = styled(Button)`
  width: 154px;
  height: 52px;
  border-radius: 12px;
  position: relative;
  padding: 0px 14px;
  display: flex;
  align-items: center;
  box-shadow: 0px 20px 87px rgba(45, 50, 59, 0.0200938),
    0px 10.125px 37.9266px rgba(45, 50, 59, 0.03475),
    0px 4px 14.1375px rgba(45, 50, 59, 0.0520312),
    0px 0.875px 5.02969px rgba(45, 50, 59, 0.08);

  margin-right: 15px;
  ${media.lg`
    width: 218px;
    height: 48px;
    margin-right: 0;
  `}

  & > div {
    color: #2d323b;
    font-size: 9px;
    font-weight: 200;
    line-height: 16px;

    ${media.lg`
      font-size: 14px;
      font-weight: 500;
    `}
  }
`;

export const QrImg = styled.img`
  height: 22px;
  width: 22px;

  ${media.lg`
    height: 29px;
    width: 29px;
  `}
`;

export const QrText = styled.span`
  white-space: normal;
  text-align: left;
  margin-left: 8px;
`;

export const ModalWrapper = styled.div`
  #inner {
    text-align: center;
    max-width: 361px;
    border-radius: 13px;
    padding: 32px 16px;
    border-radius: 12px;
    gap: 24px;
    flex-shrink: 0;
    background-color: #ffffff;
    & > span,
    div {
      color: #2d323b;
    }
  }
`;

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 44px;
  width: 288px;
  padding: 4px;
  margin: 12px auto;
  border-radius: 10px;
  background: var(--Shades-50, #f0f0f5);
`;

export const OptionButton = styled.div`
  ${({ selected }) => css`
    background-color: ${selected ? '' : 'var(--Primary-Darknet, #1c1c1c)'};
    border-radius: 8px;
    width: 141px;
    height: 44px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    & > span {
      font-weight: 600;
      font-size: 14px;
      line-height: normal;
      color: ${selected ? '#000' : '#fff'};
      text-align: center;
      font-family: 'SF Pro Display', sans-serif;
    }
  `}

  input[type=radio] {
    position: fixed;
    opacity: 0;
    pointer-events: none;
  }

  &:first-child {
    margin-right: 8px;
  }

  & > img {
    margin-right: 8px;
  }
`;
